import React, { useState } from 'react';

import { BranchList } from 'src/components/GoogleMaps/GoogleMapsTypes';

import { Button } from '../Button/Button';

import classes from './styles/Branches.scss';

function BranchList({ query, branches, children, visibleCount = 0 }: BranchList) {
    const [limit, setLimit] = useState(visibleCount || branches.length);

    return (
        <div>
            {query && (
                <p className={classes.inputHeading} data-test-id="StoreLocatorResults_summary">
                    Showing {limit} nearest stores to '{query}'
                </p>
            )}

            <ul className={classes.list}>
                {branches.slice(0, limit).map((branch) => {
                    return <li key={branch.name}>{children({ branch })}</li>;
                })}
            </ul>

            {limit < branches.length && (
                <div className={classes.ctaContainer}>
                    <Button
                        onClick={() => {
                            setLimit(branches.length);
                        }}
                        variant="primary"
                    >
                        Show all stores
                    </Button>
                </div>
            )}
        </div>
    );
}

export { BranchList };
